import { useParams } from 'react-router-dom';

import { OnboardingPage } from '~/components/pages/OnboardingPage';
import { DashboardTemplate } from '~/components/templates/DashboardTemplate';
import { Navigate } from '~/components/utils/Navigation';

export const OrganizationOnboardingRoute: React.FC = () => {
  const { organizationId } = useParams();

  if (!organizationId) {
    return <Navigate to="/" />;
  }

  return (
    <DashboardTemplate organizationId={organizationId}>
      <OnboardingPage organizationId={organizationId} />
    </DashboardTemplate>
  );
};
